<template>

    <div class="filter-button">

        <div v-if="isOpen" class="fixed w-screen h-screen top-0 left-0" @click.self="closeMenu"/>

        <div class="h-8 rounded-full px-4 flex items-center justify-between bg-black text-white z-20 relative whitespace-nowrap" @click="isOpen = !isOpen">

            <p class="text-sm font-medium">
                {{ selectedFilter.title }}
            </p>

            <DownCaret :upwards="isOpen"/>

        </div>

        <div v-if="isOpen && filters" class="filter-button__dropdown" :class="{ '--open': isOpen }">

            <div v-for="(item, index) of filters" :key="index" class="px-4 py-1" @click="setSelectedFilter(item)">

                <p class="text-sm" :class="{ 'text-blue-400': selectedFilter.key === item.key }">
                    {{ item.title }}
                </p>

            </div>

        </div>

    </div>

</template>

<script lang="ts">

    import { defineComponent, PropType, ref } from 'vue'
    import { useTranslation } from '../compositions/UseTranslation'
    import DownCaret from './Icons/DownCaret.vue'
    import { FilterInterface } from '../Interfaces/FilterInterface'

    export default defineComponent({
        name: 'FilterButton',
        components: {
            DownCaret
        },
        props: {
            filters: {
                type: Array as PropType<any[]>, required: true
            }
        },
        setup(props, { emit }) {

            const { currentLocale } = useTranslation()
            const isOpen = ref(false)
            const selectedFilter = ref(props.filters[0])

            return {

                currentLocale,
                selectedFilter,
                isOpen,
                setSelectedFilter(filter: FilterInterface) {

                    selectedFilter.value = filter
                    isOpen.value = false
                    emit('change', filter.key)

                },
                closeMenu() {

                    isOpen.value = false

                }

            }

        }
    })

</script>

<style lang="scss">

    @include component(filter-button) {

        @apply relative;

        z-index: 50;
        width: 138px;

        @include part(dropdown) {

            @apply absolute w-40 py-4 z-10 rounded-2xl mt-8 cursor-pointer bg-white font-medium scale-0;

            box-shadow: 0px 23px 40px rgba(0, 0, 0, 0.05);
            transition: transform 1s ease-out;

            @include option(open) {

                transform: scale(1);

            }

        }

    }

</style>
